<template>
  <div class="LocationMap">
    <div class="container">
      <div class="flexWrap outer">
        <div class="flexWrap">
          <span v-if="$viewportWidth < 768" class="label-filter">{{ labels.filter }}</span>
          <div class="div-select">
            <span class="div-select-label">{{ getFacilityLabel() }}</span>
            <img class="div-select-icon" :src="$context.assetsRoot+'img/arrow-down.svg'" />
            <select ref="selectFacility" v-model="currentFacility">
              <option value="all" selected>{{ labels.all_facilities }}</option>
              <option v-for="(v, k) in activeFacilities" :value="k">{{ v }}</option>
            </select>
          </div>
          <div class="div-select">
            <span class="div-select-label">{{ getCountryLabel() }}</span>
            <img class="div-select-icon" :src="$context.assetsRoot+'img/arrow-down.svg'" />
            <select ref="selectCountry" v-model="currentCountryId">
              <option value="all" selected>{{ labels.all_countries }}</option>
              <option v-for="country in countries" :value="country.id">{{ country.name }}</option>
            </select>
          </div>
        </div>
        <div v-if="!SLIDER_DISABLED" class="div-slider">
          <div v-if="getYears && selectedYearMAX" class="slider">
            <!-- left label for input range  -->
            <label class="labelYears">{{ safeLowestYear() }}</label>

            <div class="slidecontainer">
              <div ref="slider"></div>
            </div>
            <!-- right label for input range  -->
            <label class="labelYears">{{ getLatestYear }}</label>
          </div>
        </div>
      </div>
    </div>
    <!-- Map component -->
    <locations-google-map
      map-styles="locations"
      :center="getCenter"
      :markers="getMarkers"
      :zoom="getZoom"
      :refreshPayload="getRefreshPayload"
      :labels="labels"
    ></locations-google-map>
  </div>
</template>

<script>
import LocationsGoogleMap from '@components/locations-google-map';
import * as noUiSlider from 'nouislider';

const SLIDER_DISABLED = true;

export default {
  name: 'LocationMap',
  data() {
    return {
      selectedYearMAX: 0,
      selectedYearMIN: 0,
      storedMarkers: [],
      sliderRendered: false,
      sliderInstance: null,
      currentCountryId: 'all',
      currentFacility: 'all',
      SLIDER_DISABLED: SLIDER_DISABLED
    };
  },
  components: {
    LocationsGoogleMap
  },
  props: {
    locations: {
      type: Array,
      required: true
    },
    initialCenter: {
      type: Object,
      required: true
    },
    initialZoom: {
      type: Number,
      required: true
    },
    countries: {
      type: Array,
      required: true
    },
    labels: {
      type: Object,
      required: true
    },
    years: {
      type: Array,
      required: true
    }
  },
  watch: {
    selectedYearMAX() {
      this.$nextTick(() => {
        // once the year variable is init, it means we have all the info to render the slider
        this.renderSlider();
      });
    },
    getYears() {
      this.selectedYearMAX = this.getYears && this.getYears.length ? Math.round((this.getYears[this.getYears.length - 1] - this.getYears[0]) / 2) + this.getYears[0] : 0;

      this.selectedYearMIN = this.getYears && this.getYears.length ? this.getYears[0] : 0;
    },
    $currentStep(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.renderSlider(true);
      }
    }
  },
  computed: {
    getCenter() {
      const curr = this.getCurrentCountry();
      return curr
        ? {
          lat: parseFloat(curr.latitude),
          lng: parseFloat(curr.longitude)
        }
        : this.initialCenter;

    },
    getZoom() {
      const curr = this.getCurrentCountry();
      return curr ? curr.zoom : this.initialZoom;
    },
    getRefreshPayload() {
      return '' + this.selectedYearMAX + this.currentCountryId + this.currentFacility;
    },
    // gives empty array if no result
    getMarkers() {
      let markers = [];
      if (this.listOrFixture) {
        markers = this.listOrFixture
          .filter(
            p => (
              (SLIDER_DISABLED || p.year <= this.selectedYearMAX && p.year >= this.selectedYearMIN)
              && (this.currentCountryId === 'all' || p.country === this.currentCountryId)
              && (this.currentFacility === 'all' || p[this.currentFacility])
            )
          )
          .map(p => {
            return {
              position: {
                lat: parseFloat(p.latitude),
                lng: parseFloat(p.longitude)
              },
              address: p.address,
              image: p.image,
              image_alt: p.image_alt,
              city: p.city,
              year: p.year,
              mill: p.is_mill,
              office: p.is_office,
              production: p.is_production,
              restaurant: p.is_restaurant,
              cc_center: p.is_cc_center,
              brands: p.brands,
              phone: p.phone,
              fax: p.fax
            };
          });
      }
      return markers;
    },
    // get all different years from location prop
    // gives empty array if no result
    getYears() {
      const years = [];
      if (this.listOrFixture) {
        this.listOrFixture.forEach(p => {
          if (!years.includes(p.year)) {
            years.push(p.year);
          }
        });
        years.sort(function (a, b) {
          return a - b;
        });
      }
      return years.filter(y => !!y);
    },
    getLowestYear() {
      return this.getYears ? parseInt(this.getYears[0], 10) : 1800;
    },
    getLatestYear() {
      return this.getYears ? parseInt(this.getYears[this.getYears.length - 1], 10) : 2020;
    },
    activeFacilities(){
      // returns facilities that are active, filtering facilities by checking if there's at least one location in locations that has location[facilityKey] === true, es. location['is_restaurant'] === true,
      return Object.fromEntries(Object.entries(this.labels.facilities).filter(([key, value]) =>{
        return this.locations.some((location)=>{
          // removing from facilities only restaurants that are not active
          if (key === 'is_restaurant' && location[key] === true) {
            return true
          } else if (key !== 'is_restaurant'){
            return true
          }
        })
      }))

      return
    }
  },
  // async computed should be avoided
  asyncComputed: {
    async listOrFixture() {
      const placesList = this.locations
        ? this.locations
        : (await import('@fixtures/map-fixture')).mapFixture;
      return placesList;
    }
  },
  methods: {
    getCurrentCountry() {
      if (this.currentCountryId === 'all')
        return null;
      return this.countries.find(
        x => x.id === this.currentCountryId
      );
    },
    safeLowestYear() {
      return this.getLowestYear === this.getLatestYear ? this.getLowestYear - 1 : this.getLowestYear;
    },
    renderSlider(force) {
      if (SLIDER_DISABLED) {
        return;
      }
      const slider = this.$refs.slider;
      if (force || (slider && !this.sliderRendered)) {
        if (force && slider.noUiSlider) {
          slider.noUiSlider.destroy();
        }
        noUiSlider.create(slider, {
          start: [this.safeLowestYear(), this.getLatestYear],
          connect: true,
          tooltips: [false, true],
          range: {
            min: this.safeLowestYear(),
            max: this.getLatestYear
          },
          format: {
            to: function (value) {
              return Math.round(value);
            },
            from: function (value) {
              return parseInt(value, 10);
            }
          },
          pips: {
            mode: 'values',
            values: this.years.map(item => item.year),
            density: 10
          }
        });
        const origins = slider.getElementsByClassName('noUi-origin');
        origins[0].setAttribute('disabled', true);
        this.sliderRendered = true;
        //events
        // const refreshPinsDebounced = debounce(this.refreshPins, 100)
        slider.noUiSlider.on(
          'update',
          (values, handle, unencoded, tap, positions) => {
            handle
              ? (this.selectedYearMAX = Math.round(values[handle]))
              : (this.selectedYearMIN = Math.round(values[handle]));
            this.refreshPins(values[1]);
          }
        );
      }
    },
    refreshPins(position) {
      const pipList = document.getElementsByClassName('noUi-value');
      for (let i = 0; i < pipList.length; i++) {
        const pip = pipList.item(i);
        if (pip.getAttribute('data-value') < position) {
          pip.classList.add('on');
        } else {
          pip.classList.remove('on');
        }
      }
      const tooltip = document.getElementsByClassName('noUi-tooltip').item(0);
      const year = this.years.find(x => x.year === position);
      if (year) {
        tooltip.innerHTML = position + ' - ' + year.body;
        tooltip.classList.add('highlighted');
      } else {
        tooltip.innerHTML = position;
        tooltip.classList.remove('highlighted');
      }
    },
    getCountryLabel() {
      const curr = this.getCurrentCountry();
      return curr ? curr.name : this.labels.all_countries;
    },
    getFacilityLabel() {
      return this.currentFacility === 'all'
        ? this.labels.all_facilities
        : this.labels.facilities[this.currentFacility];
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~$scss/variables";
@import "~nouislider/distribute/nouislider.css";

.LocationMap {
  position: relative;

  .container {
    @media (min-width: $bootstrap-md) {
      margin-bottom: 0;
    }
  }

  .flexWrap {
    @media (min-width: $bootstrap-md) {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: left;
    }

    &:not(.outer) {
      @media (min-width: $bootstrap-md) {
        margin-bottom: -156px;
        z-index: 1;
      }
    }
  }

  .slidecontainer {
    display: inline-block;
    position: relative;
    width: 80%;
  }

  .slider {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    font-family: "Bliss Pro";
    font-size: 20px;
    height: 64px;
  }

  .labelYears {
    margin: 20px;
  }

  .range-wrap {
    position: relative;
  }

  // Styling the starting tooltip with a comicBook dialogue style
  .comicTooltip {
    width: 158px;
    height: 95px;
    color: #ffffff;
    position: absolute;
    top: 35px;
    z-index: 1;
    font-size: 14px;

    .comicTooltipBody {
      border-radius: 4px;
      background-color: $color-blue-lochmara;
      width: 100%;
      padding: 11px 9px;
    }

    &:before {
      background-color: $color-blue-lochmara;
      content: "test";
      position: absolute;
      left: 42%;
      top: -5px;
      color: $color-blue-lochmara;
      transform: rotate(-45deg);
      z-index: -1;
    }
  }
}

// ANIMATION
.fade-enter-active {
  transition: opacity 0.5s;
}

.fade-leave-active {
  opacity: 0;
}

.fade-enter, .fade-leave, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

// ---------

// noUIslider overrides

::v-deep .noUi-connect {
  background: $color-blue-lochmara !important;
}

::v-deep .noUi-horizontal .noUi-handle {
  width: 34px !important;
  height: 34px !important;
  right: -17px !important;
  top: -15px !important;
  border-radius: 100% !important;
  background-color: transparent;
}

::v-deep .noUi-horizontal {
  height: 4px !important;
}

::v-deep .noUi-handle-lower {
  pointer-events: none !important;
}

::v-deep .noUi-handle-lower:after {
  border-radius: 100% !important;
  width: 14px !important;
  height: 14px !important;
  left: 10px !important;
  top: 10px !important;
  background: #0077c4 !important;
}

::v-deep .noUi-handle-upper:before {
  border-radius: 100% !important;
  width: 16px !important;
  height: 16px !important;
  left: 9px !important;
  top: 9px !important;
  background: #0077c4 !important;
}

::v-deep .noUi-handle-upper:after {
  border-radius: 100% !important;
  width: 14px !important;
  height: 14px !important;
  left: 10px !important;
  top: 10px !important;
  background: $color-blue-lochmara !important;
  border: 2px solid white !important;
}

::v-deep .noUi-handle {
  border: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  cursor: grab !important;
  outline: none !important;
}

::v-deep .noUi-handle-upper {
  background: rgba(0, 119, 196, 0.25) !important;
}

::v-deep .noUi-target {
  background: #cfcfcf !important;
  border-radius: 0 !important;
  border: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

::v-deep .noUi-target::after {
  content: '';
  display: block;
  border: 2px solid #D7D7D7;
  position: absolute;
  right: -2px;
  width: 1px;
  top: -4px;
  bottom: -4px;
}

::v-deep .noUi-tooltip {
  border: none !important;
  background: $color-blue-lochmara !important;
  color: white !important;
  font-size: 14px !important;
  line-height: 20px;
  text-align: center;
  outline: none !important;
  top: 50px !important;
  border-radius: 5px;
  width: 70px;
  padding: 10px 15px;
  bottom: auto;
  height: auto;
  white-space: normal;
}

::v-deep .noUi-tooltip.highlighted {
  width: 158px;
}

::v-deep .noUi-tooltip:after {
  content: '';
  position: absolute;
  left: calc(50% - 14px);
  top: -28px;
  border: 14px solid transparent;
  border-bottom-color: $color-blue-lochmara;
}

//::v-deep .noUi-active {
//  outline: none !important;
//  border: none !important;
//}

::v-deep .noUi-pips-horizontal {
  padding: 0 !important;
  top: -15px !important;
  left: 0 !important;
  position: absolute !important;
}

::v-deep .noUi-marker-horizontal.noUi-marker {
  display: none;
}

::v-deep .noUi-value {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 1px solid $color-blue-lochmara;
  background: white;
  overflow: hidden;
  margin-top: -5px;
  text-indent: -1000px;
}

::v-deep .noUi-value.on {
  background: $color-blue-lochmara;
}

.div-select {
  display: inline-block;
  position: relative;
  text-align: left;
  font-family: 'Bliss Pro';
  font-size: 20px;
  line-height: 52px;
  height: 56px;
  color: #00142F;
  border: 1px solid #BFC4CA;
  border-radius: 5px;
  padding: 0 25px;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  width: 100%;
  margin-top: 20px;
  background: $color-white;

  @media (min-width: $bootstrap-md) {
    width: 192px;
    margin: 0 20px 0 0;
  }

  select {
    cursor: pointer;
    position: absolute;
    left: -1px;
    top: -1px;
    opacity: 0;
    width: calc(100% + 2px);
    height: calc(100% + 2px);
  }

  &-icon {
    position: absolute;
    right: 26px;
    top: 21px;
    width: 16px;
    height: 10px;
  }

  &-label {
    display: inline-block;
    width: calc(100% - 25px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.label-filter {
  font-family: 'Bliss Pro';
  font-size: 20px;
  color: #616365;

  @media (min-width: $bootstrap-md) {
    line-height: 1;
    padding: 0 0 1px;
  }
}

.container {
  margin-bottom: 80px;
  text-align: left;

  @media (min-width: $bootstrap-md) {
    text-align: center;
  }

  @media (min-width: $bootstrap-lg) {
    text-align: left;
  }
}

.div-slider {
  margin-top: 20px;
  display: block;
  width: 100%;

  @media (min-width: $bootstrap-lg) {
    margin-top: 0;
    display: inline-block;
    margin-left: 20px;
    min-width: 350px;
    max-width: 700px;
    width: calc(100% - 590px);
  }
}
</style>
